import React from 'react';
import './TermsAndPrivacy.scss';
import { useTranslation } from 'react-i18next';

const TermsAndPrivacy = () => {
  return (
    <div className="terms-and-privacy-page">
      <div className="container">
        <h1>ALLGEMEINE GESCHÄFTSBEDINGUNGEN (AGB)
          THANK KOMPANY GmbH
          Stand: 2025
        </h1>

        <section>
          <h2>Geltungsbereich</h2>
          <p>
             <b>(1)</b>  npDiese Allgemeinen Geschäftsbedingungen gelten für alle Verträge, Leistungen und Geschäftsbeziehungen zwischen der THANK KOMPANY GmbH (nachfolgend „Auftragnehmer“ oder „THANK KOMPANY“) und ihren Kunden (nachfolgend „Auftraggeber“). <br />
             <b>(2)</b>  Die AGB gelten ausschließlich gegenüber Unternehmern im Sinne des § 14 BGB. <br />
             <b>(3)</b>  Abweichende, entgegenstehende oder ergänzende Geschäftsbedingungen des Auftraggebers werden nur Vertragsbestandteil, sofern THANK KOMPANY deren Geltung ausdrücklich schriftlich zustimmt. <br />

          </p>
        </section>

        <section>
          <h2> Leistungsgegenstand</h2>
          <p>
            <b>(1)</b> THANK KOMPANY erbringt Beratungs-, Engineering-, IT-, SAP-, Automatisierungs- und Logistikdienstleistungen sowie internationale Beschaffungs- und Organisationsleistungen gemäß den individuell vereinbarten Vertrags- oder Projektunterlagen. <br />
            <b>(2)</b> Der konkrete Leistungsumfang ergibt sich aus dem Angebot, dem Vertrag, der Leistungsbeschreibung oder der Projektvereinbarung. <br />
            <b>(3)</b> THANK KOMPANY ist berechtigt, Leistungen ganz oder teilweise durch qualifizierte Partnerunternehmen oder Subunternehmer erbringen zu lassen, sofern dadurch die Interessen des Auftraggebers nicht beeinträchtigt werden. <br />

          </p>
        </section>

         <section>
          <h2>Vertragsschluss</h2>
          <p>
            <b>(1)</b> Angebote von THANK KOMPANY sind freibleibend und unverbindlich, sofern sie nicht ausdrücklich als verbindlich gekennzeichnet werden. <br />
            <b>(2)</b> Ein Vertrag kommt zustande durch:
            <ul>
              <li>schriftliche Annahme des Angebots,</li>
              <li>elektronische Bestätigung (z. B. per E-Mail), oder</li>
              <li>tatsächliche Inanspruchnahme der Leistung.</li>
            </ul>

          </p>
        </section>

         <section>
          <h2>Mitwirkungspflichten des Auftraggebers</h2>
         <p>
             <b>(1)</b> Der Auftraggeber stellt alle für die Leistungserbringung erforderlichen Informationen, Unterlagen, Zugänge und Ansprechpartner rechtzeitig und vollständig zur Verfügung. <br />
             <b>(2)</b> Verzögerungen infolge unzureichender Mitwirkungspflichten verlängern vereinbarte Fristen entsprechend. <br />
             <b>(3)</b> Der Auftraggeber trägt die Verantwortung für die Richtigkeit und Vollständigkeit aller bereitgestellten Informationen. <br />

         </p>
        </section>

         <section>
          <h2>Vergütung und Zahlungsbedingungen</h2>
          <p>
            <b>(1)</b> Die Vergütung richtet sich nach dem im Vertrag bzw. Angebot vereinbarten Preis- und Stundensatzmodell.
            <b>(2)</b> Rechnungen sind, sofern nicht anders vereinbart, innerhalb von 14 Tagen ohne Abzug zur Zahlung fällig.
            <b>(3)</b> Bei internationalen Projekten können zusätzliche Auslagen (Reise-, Visa-, Transport-, Kommunikationskosten) nach tatsächlichem Aufwand in Rechnung gestellt werden.
            <b>(4)</b> Bei Zahlungsverzug berechnet THANK KOMPANY Verzugszinsen nach § 288 BGB.

          </p>
        </section>

         <section>
          <h2> Leistungszeit und Verzögerungen</h2>
          <p>
            <b>(1)</b> Liefer- und Leistungstermine gelten als unverbindlich, sofern nicht ausdrücklich schriftlich als verbindlich vereinbart. <br />
            <b>(2)</b> Höhere Gewalt, Arbeitsausfälle, weltweite Krisen, politische Ereignisse oder sonstige nicht von THANK KOMPANY zu vertretende Umstände verlängern die Leistungsfristen angemessen. <br />

          </p>
        </section>

         <section>
          <h2>Gewährleistung</h2>
          <p>
            <b>(1)</b> THANK KOMPANY erbringt ihre Leistungen mit größtmöglicher Sorgfalt und nach anerkannten fachlichen Standards. <br />
            <b>(2)</b> Da es sich überwiegend um Beratungs- und Dienstleistungsprojekte handelt, schuldet THANK KOMPANY keinen garantierten Projekterfolg, sondern eine fachgerechte Leistung. <br />
            <b>(3)</b> Mängel sind innerhalb von 14 Tagen nach Kenntnis schriftlich anzuzeigen. THANK KOMPANY erhält das Recht zur Nachbesserung. <br />

          </p>
        </section>

         <section>
          <h2> Haftung</h2>
          <p>
            <b>(1)</b> THANK KOMPANY haftet für Schäden – gleich aus welchem Rechtsgrund – nur bei: 
                <ul>
                  <li>Vorsatz oder grober Fahrlässigkeit,</li>
                  <li>Verletzung des Lebens, Körpers oder der Gesundheit,</li>
                  <li>Verletzung wesentlicher Vertragspflichten (Kardinalpflichten).</li>
                </ul>
            <b>(2)</b> Bei leicht fahrlässiger Verletzung von Kardinalpflichten ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt, maximal jedoch auf den Auftragswert. <br />
            <b>(3)</b> Eine Haftung für mittelbare Schäden, entgangenen Gewinn, Produktionsausfall oder Datenverlust ist ausgeschlossen, sofern nicht Vorsatz oder grobe Fahrlässigkeit vorliegen. <br />

          </p>
        </section>

         <section>
          <h2>Datenschutz und Vertraulichkeit</h2>
          <p>
            <b>(1)</b> Beide Parteien verpflichten sich zur vertraulichen Behandlung aller im Rahmen der Zusammenarbeit erlangten Informationen gemäß DSGVO und geltendem Datenschutzrecht. <br />
            <b>(2)</b> Vertrauliche Informationen dürfen nur mit schriftlicher Zustimmung weitergegeben werden. <br />
                      <b>(3)</b> Die jeweils aktuelle Datenschutzerklärung ist unter https://www.thankompany.com/terms-and-privacy abrufbar. <br />

          </p>
        </section>

         <section>
          <h2>Nutzung von Unterlagen und Ergebnissen</h2>
          <p>
            <b>(1)</b> Alle von THANK KOMPANY erstellten Konzepte, Softwarebestandteile, Dokumentationen und Berichte bleiben geistiges Eigentum des Auftragnehmers. <br />
            <b>(2)</b> Der Auftraggeber erhält ein einfaches, nicht übertragbares Nutzungsrecht für die vereinbarte Verwendung. <br />
            <b>(3)</b> Eine Weitergabe an Dritte ist nur mit schriftlicher Zustimmung erlaubt. <br />

          </p>
        </section>

         <section>
          <h2>Internationale Projekte</h2>
          <p>
            <b>(1)</b> THANK KOMPANY ist berechtigt, Projekte weltweit zu organisieren und Dienstleistungen durch internationale Partner zu erbringen. <br />
            <b>(2)</b> Für internationale Rechtsbeziehungen gilt ausschließlich deutsches Recht, sofern nicht ausdrücklich abweichend vereinbart. <br />
            <b>(3)</b> Maßgebliche Vertragssprache ist Deutsch. <br />

          </p>
        </section>

         <section>
          <h2>Kündigung</h2>
          <p>
            <b>(1)</b> Laufende Verträge können mit einer Frist von 30 Tagen zum Monatsende schriftlich gekündigt werden, sofern nichts anderes vereinbart ist. <br />
            <b>(2)</b> Bereits erbrachte Leistungen sind vollständig zu vergüten. <br />
            <b>(3)</b> Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt. <br />
          </p>
        </section>

         <section>
          <h2>Änderung der AGB</h2>
          <p>
            THANK KOMPANY ist berechtigt, diese AGB mit Wirkung für die Zukunft anzupassen. Änderungen werden dem Auftraggeber schriftlich mitgeteilt.
          </p>
        </section>

         <section>
          <h2>Schlussbestimmungen</h2>
          <p>
            <b>(1)</b> Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. <br />
            <b>(2)</b> Gerichtsstand ist – soweit rechtlich zulässig – der Sitz der THANK KOMPANY GmbH. <br />
            <b>(3)</b> Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bedingungen unberührt. <br />
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndPrivacy;
